module.exports = __webpack_public_path__ + "static/media/logo.57ee3b60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 613
// module chunks = 0